<template>
    <div :class="className"
         @click="maskClick" />
</template>

<script>

import _ from 'lodash'

const loggingCategory = 'Modal'

export default {

    data() {
        return {
            className: 'app__container__mask',
            maskClick: this.defaultMaskClick,
        }
    },

    beforeMount() {

        this.$eventbus.$on(this.$appevents.showMask, (layer, { onMaskClick, cssModifier = '' }) => {
            this.$logger.log('Showing mask', loggingCategory)
            this.className = `app__container__mask app__container__mask--active app__container__mask--${ layer }${ cssModifier ? ` app__container__mask--${ cssModifier }` : '' }`

            if (_.isFunction(onMaskClick)) {
                this.maskClick = () => {
                    onMaskClick()
                    this.defaultMaskClick()
                }
            } else {
                this.maskClick = this.defaultMaskClick
            }
        })

        this.$eventbus.$on(this.$appevents.hideMask, () => {
            this.$logger.log('Hiding mask', loggingCategory)
            this.className = 'app__container__mask'
            this.maskClick = this.defaultMaskClick
        })
    },

    unmounted() {
        this.$eventbus.$off(this.$appevents.showMask)
        this.$eventbus.$off(this.$appevents.hideMask)
    },

    methods: {

        defaultMaskClick() {
            this.$eventbus.$emit(this.$appevents.hideMask)
        },
    },
}

</script>


<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_app.scss

.app {

    @include nested-element('container', 'mask') {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: z-index('standard-mask');
        display: none;

        &.--modal-mask {
            @include full-inner-height('base', 'small', 'mid');
            @include offset-from-header('base', 'small', 'mid');

            @include bp-min-mid {
                height: 100%;
                top: 0;
            }
        }

        @include modifier('active') {
            display: block;
        }

        @include layer-modifiers;
        @include responsive-type-modifiers;
    }
}

</style>
